














































































































































































import { Component } from "vue-property-decorator";
import { ProjectDetails } from "@/data/models/ProjectDetails";
import { uploadPdfDocument } from "@/utils/pdf/PdfDocumentRepository";
import firebase from "firebase/app";

import ClientDataSectionDialogComponent from "./ClientDataSectionDialog.vue";
import DatePickerCompoment from "@/components/common/DatePicker.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { COLOR_ACCENT, COLOR_PRIMARY, COLOR_READ_ONLY_TEXT, COLOR_READ_ONLY_TEXT_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

@Component({
  components: {
    "date-picker": DatePickerCompoment,
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class InsuranceCaseSectionComponent extends ClientDataSectionDialogComponent {
  file2: File | null = null;
  initialFileName2: string | null = null;
  fileName2: string | null = null;

  /** Whether damageDay was already persisted in Firestore (not just defaulted from projectStartDate). */
  private hasDamageDayFromFirestore = false;

  private snapshotInsuranceName = "";
  private snapshotAdditionalInsuranceInfo = "";
  private snapshotPolicyNumber = "";
  private snapshotInsuranceContactName = "";
  private snapshotInsurancePhone = "";
  private snapshotInsuranceMobile = "";
  private snapshotInsuranceEmail = "";
  private snapshotDamageNumber = "";
  private snapshotEventNumber = "";
  private snapshotDamageId = "";
  private snapshotDamageDay: firebase.firestore.Timestamp | null = null;
  private snapshotPdfDocument: string | null = null;
  private snapshotPdfDocument2: string | null = null;

  hasInitialData(): boolean {
    const cd = this.projectDetails.clientData;
    return !!(cd.insuranceName || cd.additionalInsuranceInfo || cd.policyNumber
      || cd.insuranceContactName || cd.insurancePhone || cd.insuranceMobile || cd.insuranceEmail
      || cd.damageNumber || cd.eventNumber || cd.damageId
      || this.projectDetails.pdfDocument || this.projectDetails.pdfDocument2
      || this.hasDamageDayFromFirestore);
  }

  takeSnapshot(): void {
    const cd = this.projectDetails.clientData;
    this.snapshotInsuranceName = cd.insuranceName ?? "";
    this.snapshotAdditionalInsuranceInfo = cd.additionalInsuranceInfo ?? "";
    this.snapshotPolicyNumber = cd.policyNumber ?? "";
    this.snapshotInsuranceContactName = cd.insuranceContactName ?? "";
    this.snapshotInsurancePhone = cd.insurancePhone ?? "";
    this.snapshotInsuranceMobile = cd.insuranceMobile ?? "";
    this.snapshotInsuranceEmail = cd.insuranceEmail ?? "";
    this.snapshotDamageNumber = cd.damageNumber ?? "";
    this.snapshotEventNumber = cd.eventNumber ?? "";
    this.snapshotDamageId = cd.damageId ?? "";
    this.snapshotDamageDay = cd.damageDay ?? null;
    this.snapshotPdfDocument = this.projectDetails.pdfDocument ?? null;
    this.snapshotPdfDocument2 = this.projectDetails.pdfDocument2 ?? null;
  }

  get hasChanged(): boolean {
    const cd = this.projectDetails.clientData;
    const damageDayChanged = this.snapshotDamageDay && cd.damageDay
      ? !this.snapshotDamageDay.isEqual(cd.damageDay)
      : (this.snapshotDamageDay ?? null) !== (cd.damageDay ?? null);

    return (cd.insuranceName ?? "") !== this.snapshotInsuranceName
      || (cd.additionalInsuranceInfo ?? "") !== this.snapshotAdditionalInsuranceInfo
      || (cd.policyNumber ?? "") !== this.snapshotPolicyNumber
      || (cd.insuranceContactName ?? "") !== this.snapshotInsuranceContactName
      || (cd.insurancePhone ?? "") !== this.snapshotInsurancePhone
      || (cd.insuranceMobile ?? "") !== this.snapshotInsuranceMobile
      || (cd.insuranceEmail ?? "") !== this.snapshotInsuranceEmail
      || (cd.damageNumber ?? "") !== this.snapshotDamageNumber
      || (cd.eventNumber ?? "") !== this.snapshotEventNumber
      || (cd.damageId ?? "") !== this.snapshotDamageId
      || damageDayChanged
      || (this.projectDetails.pdfDocument ?? null) !== this.snapshotPdfDocument
      || (this.projectDetails.pdfDocument2 ?? null) !== this.snapshotPdfDocument2;
  }

  async show(projectDetails: ProjectDetails) {
    this.hasDamageDayFromFirestore = !!projectDetails.clientData.damageDay;

    if (!projectDetails.clientData.damageDay) {
      projectDetails.clientData.damageDay =
        projectDetails.clientData.projectStartDate;
    }

    if (projectDetails.pdfDocument && projectDetails.pdfDocument !== "") {
      this.initialFileName = projectDetails.pdfDocument;
      this.fileName = this.initialFileName;
    } else {
      this.fileName = null;
    }

    if (projectDetails.pdfDocument2 && projectDetails.pdfDocument2 !== "") {
      this.initialFileName2 = projectDetails.pdfDocument2;
      this.fileName2 = this.initialFileName2;
    } else {
      this.fileName2 = null;
    }

    return this.showDialog(
      this.$t("clientData.insuranceCase").toString(),
      projectDetails
    );
  }

  onAccept() {
    this.isShowing = false;

    if (this.file && this.projectDetails.pdfDocument) {
      if (this.fileName && this.initialFileName !== this.fileName) {
        uploadPdfDocument(this.fileName, this.file);
      }
    }

    if (this.file2 && this.projectDetails.pdfDocument2) {
      if (this.fileName2 && this.initialFileName2 !== this.fileName2) {
        uploadPdfDocument(this.fileName2, this.file2);
      }
    }

    this.resolve && this.resolve(this.projectDetails);
  }

  get colorAccent() {
    return COLOR_ACCENT;
  }

  get colorPrimary() {
    return COLOR_PRIMARY;
  }

  get colorReadOnlyText() {
    return themed(COLOR_READ_ONLY_TEXT, COLOR_READ_ONLY_TEXT_DARK);
  }

  removeAttachedDocument(pdfIndex: number) {
    if (pdfIndex === 1) {
      this.file = null;
      this.$set(this.projectDetails, "pdfDocument", null);
      this.fileName = "";
    } else {
      this.file2 = null;
      this.$set(this.projectDetails, "pdfDocument2", null);
      this.fileName2 = "";
    }

    this.resetUploadInput(pdfIndex);
  }

  handleFileUpload(file: File, pdfIndex: number) {
    if (file && file.type === "application/pdf") {
      if (pdfIndex === 1) {
        this.file = file;
        this.fileName = file.name;
        this.$set(this.projectDetails, "pdfDocument", file.name);
      } else {
        this.file2 = file;
        this.fileName2 = file.name;
        this.$set(this.projectDetails, "pdfDocument2", file.name);
      }
    }
  }

  resetUploadInput(pdfIndex: number) {
    const refName = pdfIndex === 1 ? "upload" : "upload2";
    const uploadInput = this.$refs[refName] as HTMLInputElement | undefined;

    if (uploadInput) {
      uploadInput.value = "";
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleDrop(event: any, pdfIndex: number) {
    event.preventDefault();
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      if (file.type === "application/pdf") {
        this.handleFileUpload(file, pdfIndex);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleInputChange(event: any, pdfIndex: number) {
    const target = event.target as HTMLInputElement;
    const file = target?.files && target.files.length > 0 ? target.files[0] : null;

    if (file && file.type === "application/pdf") {
      this.handleFileUpload(file, pdfIndex);
    }

    this.resetUploadInput(pdfIndex);
  }
}
